import { useWebTranslation } from "translations";
import { MiniBanner } from "@/ui-kit";
import { objectToQueryString } from "utils/objectToQueryString";
import { getMultipetStateFromState } from "components/Signup/flow/utils/bootstrapMultiPetSignup";
import { trackSignupEvent } from "components/Signup/analytics";
import { StepName } from "components/Signup/steps/types";
import { useCurrentAnimal } from "components/Signup/store/selectors/animals";
import { useSignupStore } from "components/Signup/store/hooks";

export const MultiPetBanner = () => {
  const { t } = useWebTranslation();
  const { name } = useCurrentAnimal();
  const { getState } = useSignupStore();

  function onClick() {
    const state = getState();

    trackSignupEvent("Multipet banner clicked" as StepName, 0, state);

    const qs = objectToQueryString(getMultipetStateFromState(state));

    window.location.href = `/signup/?${qs}`;
  }

  return (
    <MiniBanner
      buttonText={t("multipet_banner.button")}
      title={t("multipet_banner.headline")}
      description={t("multipet_banner.description", { name: name ?? "" })}
      onClick={onClick}
      badgeText={t("multipet_banner.badge")}
      imageUrl="/images/insurance/multipet.png"
    />
  );
};
